import {
  DvGridComponent,
  DvQuickFilterComponent,
  DvGridToolbarComponent,
  DvActionComponent,
} from '@devinco/ui/grid';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { pendingChangesGuard } from '@core/guards/pending-changes.guard';
import { userRolesAndPermissionsGuard } from '@core/guards/user-roles-and-permissions.guard';
import {
  DvDynamicFormModule,
  DvEditorsModule,
  DvNavTabsModule,
  DvSavePanelModule,
} from '@devinco/ui/legacy';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { TranslateModule } from '@ngx-translate/core';
import { AssetsLogTabComponent } from './components/assets-tabs/assets-log-tab/assets-log-tab.component';
import { TimedMarkerMapMenuPanelComponent } from '@shared/components/timed-marker-map-menu-panel/timed-marker-map-menu-panel.component';
import { DirectivesModule } from '@shared/directives/directives.module';
import { MapModule } from '@features/map/map.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { AgGridModule } from 'ag-grid-angular';
import { AssetsPageComponent } from './assets-page.component';
import { AssetPictureDocumentTabComponent } from './components/assets-tabs/asset-picture-document-tab/asset-picture-document-tab.component';
import { AssetInformationTabComponent } from './components/assets-tabs/asset-information-tab/asset-information-tab.component';
import { AssetsTabsComponent } from './components/assets-tabs/assets-tabs.component';
import { FileUploadDialogComponent } from '@shared/components/file-upload-dialog/file-upload-dialog.component';
import { DvButtonComponent, DvTooltipDirective } from '@devinco/ui/dds';
import { AssetPropertiesTabComponent } from './components/asset-properties-tab/asset-properties-tab.component';
import { DvVerticalSplitterComponent } from '@devinco/ui/dds/splitter';
import { AssetsGridComponent } from './components/assets-grid/assets-grid.component';

export const AssetRouteName = {
  Main: 'asset',
  Information: 'information',
  PictureDocument: 'picture-document',
  Log: 'log',
  Properties: 'properties',
};

const routes: Routes = [
  {
    path: '',
    component: AssetsPageComponent,
    children: [
      {
        path: ':id',
        pathMatch: 'full',
        redirectTo: `:id/${AssetRouteName.Information}`,
      },
      {
        path: ':id',
        component: AssetsTabsComponent,
        children: [
          {
            path: AssetRouteName.Information,
            component: AssetInformationTabComponent,
            canDeactivate: [
              (component: AssetInformationTabComponent) =>
                pendingChangesGuard(component),
            ],
          },
          {
            path: AssetRouteName.PictureDocument,
            component: AssetPictureDocumentTabComponent,
          },
          {
            path: AssetRouteName.Log,
            component: AssetsLogTabComponent,
            canActivate: [
              () =>
                userRolesAndPermissionsGuard([
                  RolesAndPermissions.AssetShowInMap,
                ]),
            ],
          },
          {
            path: AssetRouteName.Properties,
            component: AssetPropertiesTabComponent,
          },
        ],
      },
    ],
  },
];
@NgModule({
  declarations: [
    AssetsPageComponent,
    AssetsGridComponent,
    AssetInformationTabComponent,
    AssetPictureDocumentTabComponent,
    AssetsLogTabComponent,
  ],
  imports: [
    AssetsTabsComponent,
    DvTooltipDirective,
    CommonModule,
    RouterModule.forChild(routes),
    DirectivesModule,
    DvGridComponent,
    DvQuickFilterComponent,
    DvGridToolbarComponent,
    DvActionComponent,
    AgGridModule,
    TranslateModule,
    DvNavTabsModule,
    DvEditorsModule,
    DvDynamicFormModule,
    DvSavePanelModule,
    DvButtonComponent,
    PipesModule,
    MapModule,
    FileUploadDialogComponent,
    TimedMarkerMapMenuPanelComponent,
    DvVerticalSplitterComponent,
  ],
})
export class AssetsPageModule {}
